import createInstance from '../utils/instance.js';
import addInterceptors from '../utils/interceptors.js';

export const apiInstance = addInterceptors(createInstance());
